import type { AppListenerMiddleware } from "@src/store/rootState";
import { setupAiListener } from "@src/store/slices/experienceBuilder/ai/listeners/setupAiListener";
import { setupCommonListener } from "@src/store/slices/experienceBuilder/common/listeners/setupCommonListener";
import { setupBasicModListener } from "@src/store/slices/experienceBuilder/basicMod/listeners/setupBasicModListener";
import { setupIdeasMixPanelListener } from "@src/store/slices/experienceBuilder/ideas/listeners/setupMixPanelListener";

export function setupExperienceBuilderListener(
  middleware: AppListenerMiddleware
) {
  setupAiListener(middleware);
  setupCommonListener(middleware);
  setupBasicModListener(middleware);
  setupIdeasMixPanelListener(middleware);
}
